/**
 * Lite 公告 API Client
 */

import { getApiBase } from './apiUtils';
import { fetcher } from '../lib/fetcher';

export interface Announcement {
  id: number;
  content: string;
  startsAt: string;
  endsAt: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface GetActiveAnnouncementsResponse {
  success: boolean;
  data: Announcement[];
}

/**
 * 取得當前有效的公告列表
 */
export async function getActiveAnnouncements(): Promise<Announcement[]> {
  const apiBase = getApiBase();
  const response = await fetcher<GetActiveAnnouncementsResponse>(
    `${apiBase}/api/lite/announcements/active`
  );
  return response.data;
}
